module.exports = __webpack_public_path__ + "static/media/EmptyQueue.30f8579b.png";